export default __webpack_public_path__ + "static/Tek_Stairs-0609ebde6abdf5dade93be5720c6cbba.png";